export default __webpack_public_path__ + "static/media/cauliflower_rice.0694085e.wav";